require('./shapeNoteToolbar.less');

var Toolbar = require('../../../../common/toolbar/toolbar');


module.exports = Toolbar.extend({

    initialize: function(options) {

        this.note = options.note;

        var lCh = this.options.channel;
        lCh.comply(this.commands, this);

        return Toolbar.prototype.initialize.call(this, options);
    },

    commands: {
        updateShapeToolbarBtn: function(noteSubType) {
            this.setActiveButton(noteSubType);
        }
    },

    onRender: function() {

        Toolbar.prototype.onRender.call(this);
        this.setActiveButton( this._getTypeShapeTypeToSetOnRender() );

    },

    /**
     * Prior to implementation of remembering the last graphic note shape type, the default
     * for both redactions and graphic notes was the note's defaultSubType.
     * Leave this as the default with the option to override.
     */
    _getTypeShapeTypeToSetOnRender: function() {
        return this.note.getDefaultShapeSubType();
    },

    setActiveButton: function(dataAttrVal) {
        Toolbar.prototype.setActiveButton.call(this, dataAttrVal);
        this.options.channel.trigger('notes:setNoteSubType', this.activeItem);
    }
});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/notes/views/header/shapeDrawingToolbars/shapeToolbar.js
 ** module id = 502
 ** module chunks = 0
 **/